<template>
  <div>
    <v-menu
      v-model="openMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px" >
      <v-text-field
        slot="activator"
        :label="$t(`entity.${entity}.${keyField}.label`)"
        v-model="componentValue"
        prepend-icon="event"
        readonly
      />
      <v-date-picker
        v-model="componentValue" 
        :first-day-of-week="1"
        :allowed-dates="allowedDates"
        scrollable
        autosave
        locale="es"/>
    </v-menu>
  </div>
</template>

<script>
import DateHelper from '@/lib/DateHelper'
const debug = require('debug')('OD::BaseFormDate')

export default {
  name: 'BaseFormDate',
  components: {},
  props: {
    keyField: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openMenu: false,
      componentValue: '',
    }
  },
  computed: {
    weekDates() {
      const dates = DateHelper.getWeekDates(this.year, this.week)
      return { firstDay: dates[0], lastDay: dates[6] }
    },
    year() {
      return this.$route.params.year ? this.$route.params.year : null
    },
    week() {
      return this.$route.params.week ? this.$route.params.week : null
    },
  },
  watch: {
    componentValue() {
      this.$emit('update:value', this.componentValue)
    },
    value() {
      this.componentValue = this.value
    },
  },
  created() {
    this.chargeData()
  },
  methods: {
    chargeData() {
      debug('chargeData', this.value)
      if (!this.value) {
        if (this.year && this.week) {
          this.componentValue = DateHelper.getWeekSaturday(this.year, this.week)
        } else {
          this.componentValue = DateHelper.getTodayShortString()
        }
      } else {
        this.componentValue = this.value
      }
    },
    allowedDates(val) {
      if (this.year && this.week) {
        const dates = DateHelper.getWeekDates(this.year, this.week)
        const allowed = dates.includes(DateHelper.getDateShortString(val))
        return allowed
      }
      return false
    },
  },
}
</script>

<style>

</style>
